import React from "react";
import { ErrorStyle } from "../components/Styled/Error.style";
import { ErrorContainer } from "../components/Styled/ErrorContainer.style";
import ErrorLabelStyle from "../components/Styled/ErrorLabel.style";
import useType from "../utils/hooks/useType";

export const inputWithError = (Component) => (props) => {
  const [error, setError] = useType("string", "");

  return (
    <ErrorContainer width={props.width}>
      <ErrorStyle error={error} width={props.width}>
        <Component {...props} onBlur={() => setError(props?.validate())} />
        <ErrorLabelStyle>{error}</ErrorLabelStyle>
      </ErrorStyle>
    </ErrorContainer>
  );
};

